import React, { useState, useEffect } from 'react';
import axiosInstance from '../../config/axiosInstance';
import axios from 'axios';
import { format, startOfMonth, set, isValid } from 'date-fns';
import JsonreportData from './Mock/JsonMock';
import newJsonMock from './Mock/newJsonMock';
import * as dateFns from 'date-fns';
import { event } from 'react-ga';
import Alert from '@mui/material/Alert';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { usageLog, } from '../../../src/store/actions/globalActions';
import classNames from 'classnames';
import { id } from 'date-fns/locale';


const AccompanimentModel = () => {
    useEffect(() => {
        try {
            if (employeeData.length == 0) {
                getListEmployees(); // Chama a função para carregar os dados uma vez ao renderizar
            }
            if (department.length == 0) {
                getListDepartment(); // Chama a função para carregar os dados uma vez ao renderizar
            }
        } catch (error) {
            console.log('error' + error)
        }

    }, []);

    //dados funcionarios ,escala e periodo//////////

    /**
     * inicializar chamada da lista de funcionarios  
     */


    const [filterEmployee, setFilterEmployee] = useState(false)
    const [employeeData, setEmployeeData] = useState([])
    const [schedule, setSchedule] = useState([])
    const [scheduleDays, setScheduleDays] = useState([])
    const [employeeSelected, setEmployeeSelected] = useState('')
    let employeeSelectedData = []
    const [employeeDataFilter, setEmployeeDataFilter] = useState([])
    const [department, setDepartment] = useState([])
    const [selectedDepartment, setselectedDepartment] = useState('')
    const [period, setPeriod] = useState([
        { name: 'JANEIRO', endDate: 31, month: 1 },
        { name: 'FEVEREIRO', endDate: 28, month: 2 },
        { name: 'MARÇO', endDate: 31, month: 3 },
        { name: 'ABRIL', endDate: 30, month: 4 },
        { name: 'MAIO', endDate: 31, month: 5 },
        { name: 'JUNHO', endDate: 30, month: 6 },
        { name: 'JULHO', endDate: 31, month: 7 },
        { name: 'AGOSTO', endDate: 31, month: 8 },
        { name: 'SETEMBRO', endDate: 30, month: 9 },
        { name: 'OUTUBRO', endDate: 31, month: 10 },
        { name: 'NOVEMBRO', endDate: 30, month: 11 },
        { name: 'DEZEMBRO', endDate: 31, month: 12 }
    ])
    const [selectPeriod, setSelectedPeriod] = useState('')
    const [periodSelect, setPeriodSelect] = useState({})
    const [currentIndex, setCurrentIndex] = useState(0); // Inicialize o índice atual com 0
    const [startDate, setStartDate] = useState(startOfMonth(new Date()))
    const [endDate, setEndDate] = useState(set(new Date(), { hours: 23, minutes: 59, seconds: 59 }))

    const handleChangePeriod = (type, event) => {
        const inputDate = new Date(event);
        if (type == 'Início') {
            setStartDate(inputDate);
        } else {
            setEndDate(inputDate);
        }
    };


    const handlePrevious = () => {
        try {
            if (currentIndex > 0) {
                setDataReport([])
                setMissingPoints(0)
                setCurrentIndex((prevIndex) => {
                    // Use a função de retorno para obter o valor atualizado
                    const newIndex = prevIndex - 1;
                    if (selectedDepartment) {
                        setEmployeeSelected(employeeDataFilter[newIndex].name ? employeeDataFilter[newIndex].name : '');
                        const newEmployeeData = employeeData.find((employee) =>
                            employee.name === employeeDataFilter[newIndex].name ? employeeDataFilter[newIndex].name : ''
                        );
                        employeeSelectedData = newEmployeeData;
                        workedDaysConfig();
                    } else {
                        setEmployeeSelected(employeeData[newIndex].name ? employeeData[newIndex].name : '');
                        const newEmployeeData = employeeData.find((employee) =>
                            employee.name === employeeData[newIndex].name ? employeeData[newIndex].name : ''
                        );
                        employeeSelectedData = newEmployeeData;
                        workedDaysConfig();
                    }
                    return newIndex; // Retorna o novo valor do índice
                });
            }
        } catch (error) {
            console.log('error:' + error);
        }
    };

    const handleNext = () => {
        try {
            const employees = selectedDepartment ? employeeDataFilter : employeeData;
            if (currentIndex < employees.length - 1) {
                setDataReport([])
                setMissingPoints(0)
                setCurrentIndex((prevIndex) => {
                    // Use a função de retorno para obter o valor atualizado
                    const newIndex = prevIndex + 1;
                    if (selectedDepartment) {
                        setEmployeeSelected(employeeDataFilter[newIndex].name ? employeeDataFilter[newIndex].name : '');
                        const newEmployeeData = employeeData.find((employee) =>
                            employee.name === employeeDataFilter[newIndex].name ? employeeDataFilter[newIndex].name : ''
                        );
                        employeeSelectedData = newEmployeeData;
                        workedDaysConfig();
                    } else {
                        setEmployeeSelected(employeeData[newIndex].name ? employeeData[newIndex].name : '');
                        const newEmployeeData = employeeData.find((employee) =>
                            employee.name === employeeData[newIndex].name ? employeeData[newIndex].name : ''
                        );
                        employeeSelectedData = newEmployeeData;
                        workedDaysConfig();
                    }
                    return newIndex; // Retorna o novo valor do índice
                });
            }
        } catch (error) {
            console.log('error : ' + error);
        }
    };



    // const [letraSelecionada, setLetraSelecionada] = useState('');
    // const [funcionariosFiltrados, setFuncionariosFiltrados] = useState([]);

    // const getFilterEmployees = (letra) => {
    //     const employees = employeeData.filter(funcionario => {
    //         funcionario.name.toLowerCase().startsWith(letra.toLowerCase())
    //     }
    //     );

    //     setFuncionariosFiltrados(employees);

    //     setLetraSelecionada(letra);
    // };


    /**
     * Chamada de lista de funcionários
     */
    const getListEmployees = async () => {
        try {
            const result = await axiosInstance.get('/employee/list')
            const data = result.data.sort((a, b) => a.name.localeCompare(b.name));
            // data.unshift({name: 'VER TODOS FUNCIONÁRIOS'})
            setEmployeeData(data)
            setEmployeeSelected(data[0].name)
            // setEmployeeSelected(result.data[0].name)
            // scheduleConfig()
            // getFilterEmployees('J')

        } catch (error) {
            setMessageError(error.message)
            setErrorBoolean(true)
            setAutoFix(false)
            console.log('funcionarios: ' + error)
        }
    }

    /**
     * chamada pra lista de departamentos
     */
    const getListDepartment = async () => {
        try {
            const result = await axiosInstance.get('/department')
            const data = result.data.sort((a, b) => a.name.localeCompare(b.name));
            data.push({ name: 'VER TODOS FUNCIONÁRIOS' })
            setDepartment(data)
        } catch (error) {
            setMessageError(error.message)
            setErrorBoolean(true)
            setAutoFix(false)
            console.log('departamento :' + error)
        }
    }
    /**
     * SELECIONAR PERIODO E O ULTIMO DIA DO MES EM NUMERO 
     */
    const objPeriod = () => {
        period.find(periodo => {
            if (periodo.name == selectPeriod) {
                setPeriodSelect(periodo)
            }
        })
        // workedDaysConfig();
    }
    /**
     * 
     * @param {*} event
     * funcionario selecionado 
     */
    const selectedEmployee = (event) => {
        setEmployeeSelected(event.target.value);
        // if (event.target.value == "VER TODOS FUNCIONÁRIOS"){
        //     setselectedDepartment(event.target.value);
        //     viewEmployees(event.target.value);
        // }
        setDataReport([])
        setMissingPoints(0)
    }

    const diffTimeSchedule = (valueInMinutes) => {
        const hours = Math.floor(valueInMinutes / 60); // Calcula as horas
        const minutes = valueInMinutes % 60;
        const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}h`;
        return formattedTime
    }

    const formatDateSchedule = (fullTime) => {
        const timeParts = fullTime == null ? ['00', '00'] : fullTime.split(":");
        const formattedTime = `${timeParts[0]}:${timeParts[1]}`;
        return formattedTime
    }


    const scheduleConfig = (config) => {
        try {
            const workdaySetConfig = config.workdaySetConfig
            const nameSchedule = config?.timeclockData.workingDay[0].description
            const daysOfWeek = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"];
            const workingDayDefinitions = {};
            const scheduleDays = []
            const nameDays = []

            for (let i = 0; i < workdaySetConfig.length; i++) {
                const timesheet = workdaySetConfig[i];
                let workingDayDefinition;

                // Lógica normal para outros dias
                workingDayDefinition = [
                    formatDateSchedule(timesheet[1].orderedShiftConfigs[0].clockInTime),
                    formatDateSchedule(timesheet[1].orderedShiftConfigs[0].clockOutTime),
                    formatDateSchedule(timesheet[1].orderedShiftConfigs[1].clockInTime),
                    formatDateSchedule(timesheet[1].orderedShiftConfigs[1].clockOutTime),
                    diffTimeSchedule(timesheet[1].orderedShiftConfigs[0].expectedWorkingMinutes + timesheet[1].orderedShiftConfigs[1].expectedWorkingMinutes)
                ];
                // }

                scheduleDays.push(timesheet[0])
                workingDayDefinitions['name'] = nameSchedule
                if (timesheet[0] == 9) {
                    workingDayDefinitions['rotation'] = workingDayDefinition;
                } else {
                    workingDayDefinitions[daysOfWeek[timesheet[0]]] = workingDayDefinition;
                }
            }

            if (scheduleDays.find(schedule => schedule == 9) == 9) {
                nameDays.push('isRotation')
            } else {
                scheduleDays.forEach(schedule => {
                    nameDays.push(daysOfWeek[schedule])
                })
            }

            setScheduleDays(nameDays)
            setSchedule(workingDayDefinitions);
        } catch (error) {
            console.log(error)
        }
    }


    const viewEmployees = () => {
        setFilterEmployee(false)
        // setselectedDepartment(false)
        // setEmployeeSelected(false)
    }
    /**
     * 
     * @param {String} event 
     * departamento
     * @function handleChangeFilter
     *  - função para filtrar funcionários por departamento
     * 
     */
    const handleChangeFilter = (event) => {
        try {
            setDataReport([])
            setFilterEmployee(true)
            let employeeFilter = []
            employeeData.forEach(employee => {
                if (event.target.value == employee.department) {
                    employeeFilter.push(employee)
                }
            })
            setselectedDepartment(event.target.value);
            const alfabetData = employeeFilter.sort((a, b) => a.name.localeCompare(b.name));
            // alfabetData.push({ name: 'Ver todos' }); // Adiciona 'Ver todos' no final

            if (event.target.value == 'VER TODOS FUNCIONÁRIOS') {
                setEmployeeDataFilter(employeeData)
                setEmployeeSelected(employeeData[0].name)
            } else {
                setEmployeeDataFilter(alfabetData);
                setEmployeeSelected(alfabetData[0].name);
            }


        } catch (error) {
            console.log('Não existe Funcionários nesse departamento :' + error)
        }
    };


    useEffect(() => {
        try {
            if (employeeSelected != '') {
                employeeSelectedData = employeeData.find(employee => employee.name == employeeSelected ? employeeSelected : '');
                // workedDaysConfig();
            }
        } catch (error) {
            console.log('error' + error)
        }
        // Coloque aqui qualquer ação que dependa do estado atualizado.
    }, [employeeSelectedData]);

    ////////////////////////////////////////////////////////////////////////////////


    // Variaveis de controle e funções de tela.
    const [alphabet] = useState(['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']);
    const [position, setPosition] = useState(0)
    const [page, setPage] = useState(0)

    function nextPageOrBack(value) {
        setPage(value)
        setDataReport([])
        workedDaysConfig();
        setMissingPoints(0)
    }

    ////////////////////////////////////////////////////////////////////////////////

    // Variavel de controle de filtro de responsividade
    const [larguraDaTela, setlarguraDaTela] = useState()
    const [alturaDaTela, setalturaDaTela] = useState()

    /**
     * @function atualizarTamanhoDaTela
     * - função para atualizar variavel por tamanho de tela 
     */
    function atualizarTamanhoDaTela() {
        setlarguraDaTela(window.innerWidth);
        setalturaDaTela(window.innerHeight);
        // Seu código de atualização com base no novo tamanho da tela aqui
        return;
    }

    //////////////////////////////////////////////////////////////////////////////////

    //dados com pontos e tratamentos, abonos
    const [dataReport, setDataReport] = useState([])
    const [type, setType] = useState('')
    const [dtRegisterADD, setDtRegisterADD] = useState(null)
    const [justficationADD, setJustificationADD] = useState('')
    const [dtRegisterUpdate, setDtRegisterUpdate] = useState(null)
    const [justficationUpadate, setJustificationUpdate] = useState('')
    const jsonReportData = JsonreportData
    const [anchorElAtividade, setAnchorElAtividade] = useState(false);
    const [row, setRow] = useState()
    const [countColumns, setCountColumns] = useState(null)
    const [ocultarPontosRemovidos, setOcultarPontosRemovidos] = useState(false);
    const [arrayOrdenado, setArrayOrdenado] = useState(false);
    const [menuTimesheet, setMenuTimesheet] = useState(false)
    const [menuTimesheetRemoved, setMenuTimesheetRemoved] = useState(false)
    const [loadingHistory, setLoadingHistory] = useState({})

    const startLoading = (message) => {
        try {
            setLoadingHistory(prevState => ({
                ...prevState,
                timeclockId: timesheetRow ? timesheetRow.timeclockId : null,
                isLoading: true,
                message: message,
                dtRef: row ? row.dtRef : null,
                type: type == 'I' ? 'Entrada' : 'Saída',
                index: idCreatedTimesheet
            }));
        } catch (error) {
            console.log(error)
        }
    };

    // Função para parar o carregamento de um card específico
    const stopLoading = () => {
        try {
            setLoadingHistory(prevState => ({
                ...prevState,
                isLoading: false,
                message: '',
                dtRef: null,
                type: '',
                index: null
            }));
        } catch (error) {
            console.log(error)
        }
    };


    function formatarData(dataString) {
        const data = new Date(dataString);
        const referenceDateUTC = new Date(dataString).getTimezoneOffset() > 0 ? new Date(new Date(dataString).getTime() + new Date(dataString).getTimezoneOffset() * 60 * 1000) : new Date(new Date(dataString).getTime() - new Date(dataString).getTimezoneOffset() * 60 * 1000);
        return referenceDateUTC.getUTCHours() + ':' + referenceDateUTC.getUTCMinutes();
    }

    function ordenarArray(array) {
        return array.sort((a, b) => {
            // Coloca os elementos não removidos primeiro
            if (a.isremoved !== b.isremoved) {
                return a.isremoved ? 1 : -1;
            }

            // Se ambos os elementos têm o mesmo valor de isremoved, ordena por tempo
            const aTime = a.event ? a.event : 0;
            const bTime = b.event ? b.event : 0;
            return aTime - bTime;
        });
    }


    function extrairHora(tempoString) {
        console.log(tempoString)
        if (tempoString) {
            const partes = tempoString.split(':');
            const hora = partes[0] ? parseInt(partes[0].trim()) : 0;
            const minuto = partes[1] ? parseInt(partes[1].trim()) : 0;
            return hora * 60 + minuto;
        } else {
            return 0;  // ou qualquer valor padrão que faça sentido no seu caso
        }
    }

    function processRow(row) {
        try {
            let historyData = [];
            let arrayOrdenado = [];

            if (row?.shifts) {
                const newRow = row?.shifts;
                newRow.forEach(timesheet => {
                    if (timesheet.author) {
                        historyData.push({
                            date: formatarData(row?.dtRef),
                            event: timesheet?.clockIn ? timesheet?.clockIn : timesheet?.clockOut,
                            timesheetAuthor: timesheet?.author,
                            type: timesheet.type,
                            timesheetRow: timesheet,
                            isRemake: timesheet.isRemake
                        });
                    }
                });
            }
            if (row) {
                if (row?.removedTimesheets && !ocultarPontosRemovidos) {
                    const newRowRemoved = row?.removedTimesheets;
                    newRowRemoved.forEach(timesheet => {
                        historyData.push({
                            event: timesheet.clock,
                            timesheetAuthor: timesheet.author,
                            type: timesheet.type,
                            creationDate: formatarData(timesheet.creationDate),
                            date: formatarData(timesheet.creationDate),
                            isremoved: true,
                            timesheetRow: timesheet,
                        });
                    });
                }

                arrayOrdenado = ordenarArray(historyData);
            }
            setArrayOrdenado(arrayOrdenado);
        } catch (error) {
            console.log(error)
        }
    }


    const handleMenuOpenAtividade = (event, row) => {
        setRow(row)
        setAnchorElAtividade(event.currentTarget);
        setType('')
        // setOpenTreatmentPoint(true)
    };

    const handleMenuCloseAtividade = () => {
        setAnchorElAtividade(false);
        setType('')
    }


    function convertDateToUTC(date) {
        return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    }

    const formatNewPontoDate = (date) => { // ponto
        const dayRef = date.dtRef;
        const [dayOfDate, hours] = date.horary.split('T');
        const [hora, minuto] = hours.split(':');
        // const minuto = dtRegisterADD.horary.slice(3, 5);
        let newDt
        newDt = new Date(date.horary);
        if (isNaN(newDt)) {
            newDt = new Date(date.dtRef)
            newDt.setHours(parseInt(hora))
            newDt.setMinutes(parseInt(minuto))
        }
        return newDt;
    }

    const [succesMessageBoolean, setSuccesMessageBoolean] = useState(false)
    const [succesMessage, setSuccesMessage] = useState('')

    const handleCloseMessageSucces = () => {
        setSuccesMessageBoolean(false)
    }

    const updateTimsheet = async () => {
        try {
            setOpenMenuTimesheet(false)
            startLoading()
            const dataTimesheet = {
                timeclockId: timesheetRow.timeclockId,
                type: timesheetRow.type == 'Entrada' ? "I" : "O",
                isRemake: timesheetRow.isRemake
            }
            const response = await axiosInstance.post('timeclocks/updateType', dataTimesheet)
            if (response.data == 'OK') {
                // Promise.reject('Tipo alterado com sucesso.')
                await workedDaysConfig();
                setOpenMenuTimesheet(false)
                setSuccesMessage('Ponto alterado com sucesso')
                setSuccesMessageBoolean(true)
                // stopLoading()
            }
            const company = JSON.parse(localStorage.getItem('companies')).find(Id => Id.companyId);
            usageLog("nova_tela_tratamento/visualizacao/alternar_tipo_de_ponto", company.companyId, company.userId)


        } catch (error) {
            setMessageError(error.message)
            setErrorBoolean(true)
            setAutoFix(false)
            console.log('não foi possivel alterar o tipo:' + error)
        }
    }

    const [idCreatedTimesheet, setIdCreatedTimesheet] = useState(null)

    /**
     * função de criação de pontos (adicionar um ponto faltante por exemplo)
     */
    const creatTimesheet = async () => {

        try {
            setOpenMenuTimesheet(false)
            const action = {
                "actionCode": "INS",
                "employeeId": employeeSelectedData.id,
                "timeclock": {
                    "type": type,
                    "justification": justficationADD,
                    "dtRegister": dateFns.format(formatNewPontoDate(dtRegisterADD), 'yyyy-MM-dd HH:mm'),
                }
            }

            const jwt = require('jsonwebtoken');
            const decodedToken = jwt.decode(localStorage.token);

            const response = await axiosInstance.post('/timeSheet/processActions', action, {
                headers: {
                    'Authorization': `Bearer ${decodedToken}`
                }
            });

            if (response.data === 'OK') {
                setType('')
                workedDaysConfig();
                onCloseAddTimesheet();
                setSuccesMessage('Ponto criado com sucesso')
                setSuccesMessageBoolean(true)
                const company = JSON.parse(localStorage.getItem('companies')).find(Id => Id.companyId);
                usageLog("nova_tela_tratamento/visualizacao/adicionar_ponto", company.companyId, company.userId)
            }

        } catch (error) {
            setMessageError(error.message)
            setErrorBoolean(true)
            setAutoFix(false)
            console.log('error :' + error)
        }
    }

    const updateTimesheet = async () => {
        try {
            setOpenMenuTimesheet(false)
            const action = {
                "actionCode": "SUB",
                "employeeId": employeeSelectedData.id,
                "timeclock": {
                    "id": timesheetRow.timeclockId,
                    "type": type,
                    "justification": justficationUpadate,
                    "dtRegister": dateFns.format(formatNewPontoDate(dtRegisterUpdate), 'yyyy-MM-dd HH:mm'),
                    "isRemake": timesheetRow.isRemake
                }
            }
            const jwt = require('jsonwebtoken');
            const decodedToken = jwt.decode(localStorage.token);

            const response = await axiosInstance.post('/timeSheet/processActions', action, {
                headers: {
                    'Authorization': `Bearer ${decodedToken}`
                }
            });


            if (response.data == 'OK') {
                setType('')
                await workedDaysConfig();
                onCloseAddTimesheet();
                setSuccesMessage('Ponto editado com sucesso')
                setSuccesMessageBoolean(true)
                onCloseAddTimesheet();
                const company = JSON.parse(localStorage.getItem('companies')).find(Id => Id.companyId);
                usageLog("nova_tela_tratamento/visualizacao/editar_ponto", company.companyId, company.userId)
                // stopLoading()
            }

        } catch (error) {
            setMessageError(error.message)
            setErrorBoolean(true)
            setAutoFix(false)
            console.log('error :' + error)
        }
    }

    const updateRemovedTimesheet = async () => {
        try {
            // setOpenMenuTimesheet(false)
            startLoading('Reativando')
            const action = {
                "employeeId": employeeSelectedData.id,
                "actions": [{
                    "action": "REM",
                    "category": "REM",
                    "categoryRemake": "REM",
                    "id": timesheetRow.timeclockId,
                    "justification": justficationUpadate || 'ok',
                    "isRemake": true,
                    "dtRegister": timesheetRow.dtRef
                }]
            }
            const jwt = require('jsonwebtoken');
            const decodedToken = jwt.decode(localStorage.token);

            const response = await axiosInstance.post('/timeSheet/actions', action, {
                headers: {
                    'Authorization': `Bearer ${decodedToken}`
                }
            });


            if (response.data == 'OK') {
                setType('')
                setMenuTimesheetRemoved(false)
                await workedDaysConfig();
                setSuccesMessage('Ponto reativado com sucesso')
                setSuccesMessageBoolean(true)
                const company = JSON.parse(localStorage.getItem('companies')).find(Id => Id.companyId);
                usageLog("nova_tela_tratamento/visualizacao/reativar_ponto", company.companyId, company.userId)
                // stopLoading()
            }

        } catch (error) {
            setMessageError(error.message)
            setErrorBoolean(true)
            setAutoFix(false)
            console.log('error :' + error)
        }
    }

    const [justficationDelete, setJustificationDelete] = useState('')
    const [timesheetDelete, setTimesheetDelete] = useState(false)

    const openModalTimesheetDelete = () => {
        setTimesheetDelete(true)
    }
    const closeModalTimesheetDelete = () => {
        setTimesheetDelete(false)
    }

    const deleteTimesheet = async () => {
        // this.setState({ loading: true })
        try {
            setOpenMenuTimesheet(false)
            closeModalTimesheetDelete()
            const action = {
                "actionCode": "REM",
                "employeeId": employeeSelectedData.id,
                "timeclock": {
                    "id": timesheetRow.timeclockId,
                    "type": type,
                    "justification": justficationDelete,
                    "dtRegister": null,
                    "isRemake": timesheetRow.isRemake
                }
            }
            const jwt = require('jsonwebtoken');
            const decodedToken = jwt.decode(localStorage.token);

            const response = await axiosInstance.post('/timeSheet/processActions', action, {
                headers: {
                    'Authorization': `Bearer ${decodedToken}`
                }
            });

            if (response.data == 'OK') {
                workedDaysConfig();
                closeModalTimesheetDelete();
                setSuccesMessage('Ponto deletado com sucesso')
                setSuccesMessageBoolean(true)
                // stopLoading()
            }

            setType('')
            onCloseAddTimesheet();
            const company = JSON.parse(localStorage.getItem('companies')).find(Id => Id.companyId);
            usageLog("nova_tela_tratamento/visualizacao/excluir_ponto", company.companyId, company.userId)

        } catch (error) {
            setMessageError('ocorreu um erro ao deletar o ponto!')
            setErrorBoolean(true)
            setAutoFix(false)
            console.log('error :' + error)
        }
    }

    const [dayMissingJustification, setDayMissingJustification] = useState('')
    const [openModalMissingDay, setOpenModalMissingDay] = useState(false)

    const handleOpenModalMissingDay = () => {
        setOpenModalMissingDay(true)
    }
    const handleCloseModalMissingDay = () => {
        setOpenModalMissingDay(false)
    }

    const missingDay = async () => {
        // this.setState({ loading: true })
        try {
            const action = [{
                "action": "FAL",
                "justification": dayMissingJustification,
                "dtRegister": timesheetRow.dtRef
            }];
            await axiosInstance
                .post('timeSheet/actions', {
                    employeeId: employeeSelectedData.id,
                    actions: action,
                }).then(response => {
                    if (response.data == 'OK') {
                        workedDaysConfig();
                        handleCloseModalMissingDay();
                    }
                })
            setType('')
            onCloseAddTimesheet();

        } catch (error) {
            setMessageError(error.message)
            setErrorBoolean(true)
            setAutoFix(false)
            console.log('error :' + error)
        }
    }
    // let newJsonReportData = []
    // const  [newJsonReportData,setNewJsonReportData] = useState([])
    /**
     * requisição para chamada dos pontos do funcionário
     */

    const formatDatePeriod = (date) => {
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        const hours = ('0' + date.getHours()).slice(-2);
        const minutes = ('0' + date.getMinutes()).slice(-2);

        return `${year}/${month}/${day} ${hours}:${minutes}`;
    }

    const [errorBoolean, setErrorBoolean] = useState(false)
    const [messageError, setMessageError] = useState('')

    const handleCloseErrorMessage = () => {
        setErrorBoolean(false)
    }

    const getTimesheetEmployees = async () => {
        try {
            const company = JSON.parse(localStorage.getItem('companies')).find(Id => Id.companyId);
            const nowDate = new Date()
            const nowMonth = nowDate.getMonth() + 1
            const findMonth = period.find(month => month.month == nowMonth)
            const startPeriod = formatDatePeriod(startDate)
            const endPeriod = formatDatePeriod(endDate)
            const dt = {
                "startPeriod": startPeriod,
                "endPeriod": endPeriod,
                "employeeId": employeeSelectedData.id,
                "companyId": company.companyId
            }
            const response = await axios.post('https://puntuapi.eastus.cloudapp.azure.com/api/Timesheet/getEmployeeTimesheet', dt)
            // const response = await axios.post('http://10.68.1.148:3000/timesheet/getEmployeeTimesheet', dt)
            usageLog("nova_tela_tratamento/visualizacao/nava_tela", company.companyId, company.userId)

            const data = response.data;
            return data
        } catch (error) {
            setAutoFix(false)
            console.log('Não foi possivel encontrar os pontos:' + error)
        }
    }




    const [autoFix, setAutoFix] = useState(false)
    const postAutoFix = async () => {
        try {
            setAutoFix(true)
            const company = JSON.parse(localStorage.getItem('companies')).find(Id => Id.companyId);
            const nowDate = new Date()
            const nowMonth = nowDate.getMonth() + 1
            const findMonth = period.find(month => month.month == nowMonth)
            const jwt = require('jsonwebtoken');
            const decodedToken = jwt.decode(localStorage.token);
            const companyData = JSON.parse(localStorage.getItem('companies')).find(name => name.companyName);

            const startPeriod = formatDatePeriod(startDate)
            const endPeriod = formatDatePeriod(endDate)

            const dt = {
                "startPeriod": startPeriod,
                "endPeriod": endPeriod,
                "employeeId": employeeSelectedData.id,
                "companyId": decodedToken.companyId
            }
            const response = await axios.post('https://puntuapi.eastus.cloudapp.azure.com/api/Timesheet/autofixTimesheet', dt)
            usageLog("nova_tela_tratamento/visualizacao/pré_assinalado", company.companyId, company.userId)

            // const response = await axios.post('http://10.0.0.199:3000/timesheet/autofixTimesheet', dt)
            if (response.data == 'OK') {
                setAutoFix(false)
                setSuccesMessage('Pontos completados com sucesso')
                setSuccesMessageBoolean(true)
            }
            workedDaysConfig();

        } catch (error) {
            setMessageError(error.message)
            setErrorBoolean(true)
            setAutoFix(false)
        }
    }




    /**
     * função para pegar json do mock e reproduzir os dados
     * tratamento de dados  
     */

    const converterParaHoras = (minutos) => {
        const horas = Math.floor(minutos / 60);
        const minutosRestantes = minutos % 60;
        // Adiciona um zero à esquerda se a hora ou os minutos forem menores que 10
        const horasFormatadas = horas < 10 ? `0${horas}` : horas;
        const minutosFormatados = minutosRestantes < 10 ? `0${minutosRestantes}` : minutosRestantes;

        return `${horasFormatadas}:${minutosFormatados}`;
    };

    const workedDaysShifts = (workedDay, events, incompletShifts, dtRef) => {
        let shifts = [];
        const processShift = (shift, type, dtRegister) => {
            const clockTime = new Date(shift.dtRegister);
            const clockHour = clockTime.getUTCHours().toString().padStart(2, '0') + ':' + clockTime.getUTCMinutes().toString().padStart(2, '0');
            return {
                [type]: clockHour,
                timeclockId: shift.id,
                adressLocation: { lat: shift.lat || null, lng: shift.lng || null },
                dtRef: workedDay?.referenceDate ? workedDay?.referenceDate : dtRegister,
                author: shift.category ? shift.User ? `${shift.User.name} (Gestor)` : 'Gestor' : employeeData.find(employee => employee.id == shift.employeeId).name,
                type: type === 'clockIn' ? "Entrada" : "Saída",
                justification: shift.description || '',
                timezone: shift.timezonename || '',
                offline: shift.offline || false,
                isWeb: shift.isRegisteredWeb || false,
                isTimeclokManager: !!shift.description,
                hash256: shift.hash256 || null,
                isRemake: !!shift.category,
                category: shift.category || '',
                eventsLocation: !!events.find(event => event.timeclockId == shift.id),
                dtRegister: shift.dtRegister
            };
        };

        if (workedDay) {
            workedDay.shifts.forEach((shift) => {
                shifts.push(processShift(shift.clockIn, 'clockIn'), processShift(shift.clockOut, 'clockOut'));
            });
        }

        if (workedDay) {
            incompletShifts.forEach((incompletShift) => {
                const clock = incompletShift.clockIn || incompletShift.clockOut;
                const dtRegister = clock.dtRegister.split("T")[0] + 'T' + '00:00:00.000Z';
                // const findDay = shifts.find(point => point.dtRef == dtRegister);
                const findDay = dtRef == dtRegister

                if (findDay) {
                    if (incompletShift.clockIn) {
                        shifts.push(processShift(clock, 'clockIn', dtRegister), {});
                    } else {
                        shifts.push(processShift(clock, 'clockOut', dtRegister), {});
                    }
                }
            });
        } else {
            incompletShifts.forEach((incompletShift) => {
                const clock = incompletShift.clockIn || incompletShift.clockOut;
                const dtRegister = clock.dtRegister.split("T")[0] + 'T' + '00:00:00.000Z';
                const refereceDate = dtRef.split("T")[0] + 'T' + '00:00:00.000Z';
                // const findDay = shifts.find(point => point.dtRef == dtRegister);
                const findDay = refereceDate == dtRegister

                if (findDay) {
                    if (incompletShift.clockIn) {
                        shifts.push(processShift(clock, 'clockIn', dtRegister), {});
                    } else {
                        shifts.push(processShift(clock, 'clockOut', dtRegister), {});
                    }
                }
            });
        }

        return shifts;
    };



    const workedDaysConfig = async () => {
        try {
            setAutoFix(true)
            const dataJsonWorkdays = []
            const newJsonReportData = await getTimesheetEmployees();
            if (newJsonReportData) {
                scheduleConfig(newJsonReportData);
            } else {
                setSchedule([])
                setDataReport([])
            }
            const nowDate = new Date()
            const nowMonth = nowDate.getMonth() + 1
            const daysOfWeek = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"];
            const events = await eventEmployee(startDate, endDate);

            if (selectPeriod == '') {
                setSelectedPeriod(period.find(month => month.month == nowMonth))
            }

            let totalShifts = 2
            let isRotation = false

            newJsonReportData && newJsonReportData.timeclockData.workedDays.map(workedDay => {
                const monthRef = convertDateToUTC(new Date(workedDay.referenceDate))
                const dtRef = new Date(workedDay.referenceDate).getUTCDate().toString().padStart(2, '0') + '/' +
                    (monthRef.getUTCMonth() + 1).toString().padStart(2, '0') + ' - ' + daysOfWeek[new Date(workedDay.referenceDate).getUTCDay()]

                const schedule = newJsonReportData.workdaySetConfig.find(dayWork => {
                    if (dayWork[0] == 9) {
                        isRotation = true
                        return true
                    }
                    return new Date(workedDay.referenceDate).getUTCDay() == dayWork[0]
                })
                let countExpected = 0
                const expectedTimesheet = schedule ? schedule[1].orderedShiftConfigs?.map(count => {
                    if (count.clockInTime) {
                        countExpected = countExpected + 1
                    }
                    if (count.clockOutTime) {
                        countExpected = countExpected + 1
                    }
                })
                    : countExpected

                const holidays = newJsonReportData?.timeclockData.config.length > 0 ? newJsonReportData?.timeclockData.config?.[0].holidaysData : []
                const findHoliday = holidays.filter(holiday => new Date(holiday.dtRef).getTime() == new Date(workedDay.referenceDate).getTime())

                const allowancesAndDaysOff = newJsonReportData?.timeclockData.allowancesAndDaysOff.filter(allowance => {
                    const dtFrom = new Date(allowance.dtFrom)
                    const dtTo = new Date(allowance.dtTo)
                    const dtFromUTC = dtFrom.getTimezoneOffset();
                    const dtToUTC = dtTo.getTimezoneOffset();

                    const newDtFrom = dtFromUTC > 0 ? new Date(dtFrom.getTime() + dtFromUTC * 60 * 1000) : new Date(dtFrom.getTime() - dtFromUTC * 60 * 1000);
                    const newDtTo = dtToUTC > 0 ? new Date(dtTo.getTime() + dtToUTC * 60 * 1000) : new Date(dtTo.getTime() - dtToUTC * 60 * 1000);
                    const referenceDateUTC = new Date(workedDay.referenceDate).getTimezoneOffset() > 0 ? new Date(new Date(workedDay.referenceDate).getTime() + new Date(workedDay.referenceDate).getTimezoneOffset() * 60 * 1000) : new Date(new Date(workedDay.referenceDate).getTime() - new Date(workedDay.referenceDate).getTimezoneOffset() * 60 * 1000);

                    if (referenceDateUTC.getTime() >= newDtFrom.getTime() && referenceDateUTC.getTime() <= newDtTo.getTime()) {
                        return allowance
                    }
                })

                const removedArray = []

                const removedTimesheets = newJsonReportData?.timeclockData.timeclockRemakeRemoveds.filter(removed => {
                    const dtFrom = removed.dtRegister.slice(0, 11) + "00:00:00.000Z";
                    if (new Date(dtFrom).getTime() == new Date(workedDay.referenceDate).getTime()) {
                        const date = new Date(removed.dtRegister).getTimezoneOffset() > 0 ? new Date(new Date(removed.dtRegister).getTime() + new Date(removed.dtRegister).getTimezoneOffset() * 60 * 1000) : new Date(new Date(removed.dtRegister).getTime() - new Date(removed.dtRegister).getTimezoneOffset() * 60 * 1000);
                        const horas = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
                        const minutos = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
                        const clock = horas + ':' + minutos;
                        const author = removed.User.name
                        removedArray.push({
                            clock: clock,
                            author: author,
                            creationDate: removed.creationDate,
                            type: removed.type,
                            timeclockId: removed.id,
                            dtRef: removed.dtRegister
                        })
                    }
                })


                let clockDay = {
                    data: dtRef,
                    shifts: [],
                    description: '',
                    status: 'ok',
                    complete: true,
                    isSchedule: schedule ? true : false,
                    dtRef: workedDay.referenceDate,
                    entryOne: {},
                    saleOne: {},
                    entryTwo: {},
                    saleTwo: {},
                    allowancesAndDaysOff: allowancesAndDaysOff.length > 0 ? typesAllowaces.find(type => type.value == allowancesAndDaysOff[0].category) : {},
                    allowanceData: allowancesAndDaysOff,
                    incompletShift: [],
                    totalWorkingInMinutes: workedDay.totalWorkingMinutes > 0 ? converterParaHoras(workedDay.totalWorkingMinutes) : 0,
                    isHolidays: findHoliday ? findHoliday[0]?.description : null,
                    totalShifts: totalShifts,
                    events: null,
                    isScheduleRotation: isRotation,
                    removedTimesheets: removedArray
                }
                const workedDayShifts = workedDaysShifts(workedDay, events, newJsonReportData?.timeclockData.incompletShifts, workedDay.referenceDate)

                // totalShifts = (workedDayShifts.length / 2) >= totalShifts ? (workedDayShifts.length / 2) : totalShifts
                // clockDay.totalShifts = totalShifts

                for (let i = 0; i < workedDayShifts.length; i++) {
                    if (i >= 8) {
                        if (workedDayShifts[i].clockIn) {
                            clockDay.incompletShift.push(workedDayShifts[i]);
                        } else if (workedDayShifts[i].clockOut) {
                            clockDay.incompletShift.push(workedDayShifts[i])
                        }
                    }
                }

                clockDay.shifts = workedDayShifts
                let isEvent = false
                workedDayShifts.map(work => {
                    if (work.eventsLocation) {
                        isEvent = true
                    }
                })
                clockDay.events = isEvent

                let countTimeCloks = workedDayShifts.length
                clockDay.complete = (countTimeCloks - countExpected) >= 0 ? true : false
                dataJsonWorkdays.push(clockDay)
            })

            newJsonReportData && newJsonReportData.timeclockData.incompletShifts.map((incompletShift, index) => {
                const dtReference = incompletShift.clockIn ? incompletShift.clockIn.dtRegister : incompletShift.clockOut.dtRegister
                const schedule = newJsonReportData.workdaySetConfig.find(dayWork => {
                    if (dayWork[0] == 9) {
                        isRotation = true
                        return true
                    }
                    return new Date(dtReference).getUTCDay() == dayWork[0]
                })

                const holidays = newJsonReportData?.timeclockData.config.length > 0 ? newJsonReportData?.timeclockData.config?.[0].holidaysData : []
                const findHoliday = holidays.filter(holiday => new Date(holiday.dtRef).getTime() == new Date(dtReference).getTime())
                const allowancesAndDaysOff = newJsonReportData?.timeclockData.allowancesAndDaysOff.filter(allowance => {
                    const dtFrom = new Date(allowance.dtFrom)
                    const dtTo = new Date(allowance.dtTo)
                    const dtFromUTC = dtFrom.getTimezoneOffset();
                    const dtToUTC = dtTo.getTimezoneOffset();

                    const newDtFrom = dtFromUTC > 0 ? new Date(dtFrom.getTime() + dtFromUTC * 60 * 1000) : new Date(dtFrom.getTime() - dtFromUTC * 60 * 1000);
                    const newDtTo = dtToUTC > 0 ? new Date(dtTo.getTime() + dtToUTC * 60 * 1000) : new Date(dtTo.getTime() - dtToUTC * 60 * 1000);

                    const referenceDateUTC = new Date(dtReference).getTimezoneOffset() > 0 ? new Date(new Date(dtReference).getTime() + new Date(dtReference).getTimezoneOffset() * 60 * 1000) : new Date(new Date(dtReference).getTime() - new Date(dtReference).getTimezoneOffset() * 60 * 1000);

                    if (referenceDateUTC.getTime() >= newDtFrom.getTime() && referenceDateUTC.getTime() <= newDtTo.getTime()) {
                        return allowance
                    }
                })

                const removedArray = []

                const removedTimesheets = newJsonReportData?.timeclockData.timeclockRemakeRemoveds.filter(removed => {
                    const dtFrom = removed.dtRegister.slice(0, 11) + "00:00:00.000Z";
                    const dtRef = dtReference.slice(0, 11) + "00:00:00.000Z"
                    if (new Date(dtFrom).getTime() == new Date(dtRef).getTime()) {
                        const date = new Date(removed.dtRegister).getTimezoneOffset() > 0 ? new Date(new Date(removed.dtRegister).getTime() + new Date(removed.dtRegister).getTimezoneOffset() * 60 * 1000) : new Date(new Date(removed.dtRegister).getTime() - new Date(removed.dtRegister).getTimezoneOffset() * 60 * 1000);
                        const horas = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
                        const minutos = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
                        const clock = horas + ':' + minutos;
                        const author = removed.User.name
                        removedArray.push({
                            clock: clock,
                            author: author,
                            creationDate: removed.creationDate,
                            type: removed.type,
                            timeclockId: removed.id,
                            dtRef: removed.dtRegister
                        })
                    }
                })

                let clockDay = {
                    data: '',
                    shifts: [],
                    description: '',
                    status: 'ok',
                    complete: false,
                    isSchedule: schedule ? true : false,
                    dtRef: dtReference,
                    entryOne: {},
                    saleOne: {},
                    entryTwo: {},
                    saleTwo: {},
                    allowancesAndDaysOff: allowancesAndDaysOff.length > 0 ? typesAllowaces.find(type => type.value == allowancesAndDaysOff[0].category) : {},
                    allowanceData: allowancesAndDaysOff,
                    incompletShift: [],
                    isHolidays: findHoliday ? findHoliday[0]?.description : null,
                    totalShifts: totalShifts,
                    events: null,
                    removedTimesheets: removedArray
                }

                const workedDayShifts = workedDaysShifts(null, events, newJsonReportData?.timeclockData.incompletShifts, dtReference)
                clockDay.shifts = workedDayShifts
                // totalShifts = (workedDayShifts.length / 2) >= totalShifts ? (workedDayShifts.length / 2) : totalShifts
                // clockDay.totalShifts = totalShifts

                workedDayShifts.map(shift => {
                    if (shift) {
                        clockDay.incompletShift.push(shift)
                    }
                })

                let isEvent = false
                workedDayShifts.map(work => {
                    if (work.eventsLocation) {
                        isEvent = true
                    }
                })
                clockDay.events = isEvent


                const monthRef = new Date(dtReference)
                // monthRef.setUTCMonth(monthRef.getUTCMonth() + 1);
                const dtRef = new Date(dtReference).getUTCDate().toString().padStart(2, '0') + '/' +
                    (monthRef.getUTCMonth() + 1).toString().padStart(2, '0') + ' - ' + daysOfWeek[new Date(dtReference).getUTCDay()]
                clockDay.data = dtRef

                const clock = new Date(dtReference).getUTCHours().toString().padStart(2, '0') + ':' + new Date(dtReference).getUTCMinutes().toString().padStart(2, '0')
                // clockDay.shifts.push({ clockIn: incompletShift.clockIn ? incompletShift.clockIn.type == 'I' ? clock : '' : '', clockOut: incompletShift.clockOut ? incompletShift.clockOut.type == 'O' ? clock : '' : '' })
                let findDataTimeclock = dataJsonWorkdays.find(timeclock => timeclock.data == dtRef)


                dataJsonWorkdays.push(clockDay)
            })


            let newdataReport = []
            let currentDate = new Date(startDate);

            for (let data = currentDate; data <= endDate; data.setUTCDate(data.getUTCDate() + 1)) {
                const newData = data
                // let existDate = false
                // const findDate = dataJsonWorkdays.find(timesheet => { // só encontrou o primeiro dia 14 (find retorna SOMENTE o primeiro elemento)
                //     if (new Date(timesheet.dtRef).getUTCDate() == newData.getUTCDate() && new Date(timesheet.dtRef).getUTCMonth() == newData.getUTCMonth()) {
                //         existDate = true
                //         return newdataReport.push(timesheet)
                //     }
                // })
                const findDateInTimesheet = dataJsonWorkdays.filter(wd => new Date(wd.dtRef).getUTCDate() == newData.getUTCDate() && new Date(wd.dtRef).getUTCMonth() == newData.getUTCMonth())
                for (let i = 1; i < findDateInTimesheet.length; i++) {
                    findDateInTimesheet[0].shifts = findDateInTimesheet[0].shifts.concat(findDateInTimesheet[i].shifts)

                }

                let existDate = findDateInTimesheet.length > 0;
                if (existDate) {
                    const removedDuplicate = removerShiftsDuplicados(findDateInTimesheet[0]) // remover duplicados, verificar no back a causa 

                    if (Math.ceil(removedDuplicate.shifts.length / 2) > totalShifts) {
                        totalShifts = Math.ceil(removedDuplicate.shifts.length / 2)
                    }
                    newdataReport.push(removedDuplicate) //todos os turnos foram concatenados no primeiro WorkDay
                }


                if (!existDate) {
                    const dtRef = newData.getUTCDate().toString().padStart(2, '0') + '/' +
                        (newData.getUTCMonth() + 1).toString().padStart(2, '0') + ' - ' + daysOfWeek[newData.getUTCDay()]
                    const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', timeZoneName: 'short' };

                    const dataLocalFormatted = new Intl.DateTimeFormat('en-US', options).format(newData);
                    const schedule = newJsonReportData?.workdaySetConfig.find(dayWork => {
                        return new Date(dataLocalFormatted).getUTCDay() == dayWork[0]
                    })
                    const holidays = newJsonReportData?.timeclockData.config.length > 0 ? newJsonReportData?.timeclockData.config?.[0].holidaysData : []

                    const findHoliday = holidays ? holidays.filter(holiday => {
                        const holidayDate = new Date(holiday.dtRef);
                        const userTimeZoneOffset = holidayDate.getTimezoneOffset(); // Obtém o offset do fuso horário local do usuário em minutos

                        // Ajusta para o fuso horário local do usuário
                        let horary
                        if (userTimeZoneOffset > 0) {
                            horary = new Date(holidayDate.getTime() + userTimeZoneOffset * 60 * 1000);
                        } else {
                            horary = new Date(holidayDate.getTime() - userTimeZoneOffset * 60 * 1000);
                        }

                        // const formattedHoliday = new Intl.DateTimeFormat('en-US', options).format(horary);
                        return horary.getTime() === new Date(dataLocalFormatted).getTime();
                    }) : []


                    const allowancesAndDaysOff = newJsonReportData ? newJsonReportData?.timeclockData.allowancesAndDaysOff.filter(allowance => {
                        const dtFrom = new Date(allowance.dtFrom)
                        const dtTo = new Date(allowance.dtTo)
                        const dtFromUTC = dtFrom.getTimezoneOffset();
                        const dtToUTC = dtTo.getTimezoneOffset();

                        const newDtFrom = dtFromUTC > 0 ? new Date(dtFrom.getTime() + dtFromUTC * 60 * 1000) : new Date(dtFrom.getTime() - dtFromUTC * 60 * 1000);
                        const newDtTo = dtToUTC > 0 ? new Date(dtTo.getTime() + dtToUTC * 60 * 1000) : new Date(dtTo.getTime() - dtToUTC * 60 * 1000);

                        if (new Date(dataLocalFormatted).getTime() >= newDtFrom.getTime() && new Date(dataLocalFormatted).getTime() <= newDtTo.getTime()) {
                            return allowance
                        }
                    }

                    ) : []

                    let clockDay = {
                        data: dtRef,
                        shifts: [],
                        description: findHoliday.length > 0 ? findHoliday[0].description : '',
                        status: 'ok',
                        complete: false,
                        isSchedule: schedule && new Date(dataLocalFormatted) < new Date() && findHoliday.length == 0 ? true : false,
                        dtRef: dataLocalFormatted,
                        entryOne: {},
                        saleOne: {},
                        entryTwo: {},
                        saleTwo: {},
                        isHolidays: findHoliday ? findHoliday[0]?.description : null,
                        allowancesAndDaysOff: allowancesAndDaysOff.length > 0 ? typesAllowaces.find(type => type.value == allowancesAndDaysOff[0].category) : {},
                        allowanceData: allowancesAndDaysOff,
                        incompletShift: []
                    }
                    newdataReport.push(clockDay)
                }
            }
            setCountColumns(totalShifts)
            if (newdataReport.length > 0 && row) {
                const filterRow = newdataReport.find(day => day.data == row.data)
                setRow(filterRow)
                processRow(row)
            }
            setDataReport(newdataReport);
            bigNumbersTimesheet(newdataReport, newJsonReportData?.workdaySetConfig, newJsonReportData);
            setAutoFix(false)
            stopLoading()

        } catch (error) {
            setMessageError('ocorreu um erro ao deletar o ponto!')
            setErrorBoolean(true)
            setAutoFix(false)
            stopLoading()
            console.log('error:' + error)
        }
    }

    function removerShiftsDuplicados(objeto) {
        try {
            if (!objeto || !objeto.shifts || !Array.isArray(objeto.shifts)) {
                return objeto;
            }

            const shiftsUnicos = [];
            const dtRegisters = new Set();

            for (const shift of objeto.shifts) {
                if (shift && shift.timeclockId) {
                    if (!dtRegisters.has(shift.timeclockId)) {
                        dtRegisters.add(shift.timeclockId)
                        shiftsUnicos.push(shift);
                    }
                }
            }

            // Filtra os objetos vazios
            objeto.shifts = shiftsUnicos.filter(shift => Object.keys(shift).length > 0);

            return objeto;
        } catch (error) {
            console.error(error)
        }
    }
    ////////////////////////////////////////////////////MENU DO PONTO////////////////////////////////////////////////////////////////////

    const [openMenuTimesheet, setOpenMenuTimesheet] = useState(false);
    const [openModalActionsTimesheet, setOpenModalActionsTimesheet] = useState(false)
    const [modalPicture, setModalPicture] = useState(false)
    const [fotoModal, setFotoModal] = useState(null)
    const [viewLocation, setViewLocation] = useState(false)
    const [timesheetRow, setTimesheetRow] = useState(null)



    const handleOpenActionsModal = () => {
        setOpenModalActionsTimesheet(true);
        getModalPicture(timesheetRow.timeclockId);
    }
    const handleCloseActionsModal = () => {
        setOpenModalActionsTimesheet(false)
        setFotoModal(null)
        handleCloseViewLocation();
        setOpenMenuTimesheet(false)
    }

    const handleViewLocation = () => {
        setViewLocation(true)
    }
    const handleCloseViewLocation = () => {
        setViewLocation(false)
    }

    const handleOpenPicture = () => {
        setModalPicture(true)
    }
    const handleClosePicture = () => {
        setModalPicture(false)
    }

    const getModalPicture = async (value) => {
        try {
            if (!modalPicture) {
                axiosInstance({
                    url: 'timeclocks/photo',
                    data: {
                        timeclockId: value
                    },
                    method: 'POST',
                    responseType: 'blob', // important
                })
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('show', '{file}.jpeg'); //or any other extension
                        document.body.appendChild(link);
                        // setModalPicture(true)
                        setFotoModal(link)
                        // this.preenchePictureModal(value);
                    })
                    .catch((error) => {
                        // this.errorPictureOpen(value)
                    });
            } else {
                setModalPicture(false)
            }
        } catch (error) {
            setMessageError(error.message)
            setErrorBoolean(true)
            setAutoFix(false)
            console.log(error)
        }

    };



    ///////////////////////////////ABONOS//////////////////////////////////////////////////////
    /**
     * variaveis e função para abertura de tratamento de ponto
     */
    const [openTreatmentPoint, setOpenTreatmentPoint] = useState(false)
    const [editPoint, setEditPoint] = useState(false)
    const [addPoint, setAddPoint] = useState(false)
    const [openWarningAddTimesheet, setOpenWarningTimesheet] = useState(false)
    const [defautAdd, setDefautAdd] = useState(null)

    const handleOpenModalUpdate = () => {
        try {
            setEditPoint(true)
            if (row) {
                let data = new Date(timesheetRow.dtRef);
                let horaClock = timesheetRow.clockIn ? timesheetRow.clockIn.split(':') : timesheetRow.clockOut.split(':');

                data.setUTCHours(horaClock[0], horaClock[1]);

                let dataHora = data.toISOString();
                let ano = data.getUTCFullYear();
                let mes = data.getUTCMonth() + 1;  // Os meses começam do 0 em JavaScript
                let dia = data.getUTCDate();
                let hora = data.getUTCHours();
                let minuto = data.getUTCMinutes();

                // Adiciona um zero à esquerda se o mês, dia, hora ou minuto for menor que 10
                mes = mes < 10 ? '0' + mes : mes;
                dia = dia < 10 ? '0' + dia : dia;
                hora = hora < 10 ? '0' + hora : hora;
                minuto = minuto < 10 ? '0' + minuto : minuto;

                let dataFormatada = `${ano}-${mes}-${dia}T${hora}:${minuto}`;


                setDtRegisterUpdate({
                    horary: dataFormatada,
                    dtRef: row.dtRef
                });
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleOpenModalADD = () => {
        try {
            setAddPoint(true)
            if (row) {
                let data = new Date(row.dtRef);
                data.setUTCHours("00", "00");

                let ano = data.getUTCFullYear();
                let mes = data.getUTCMonth() + 1;  // Os meses começam do 0 em JavaScript
                let dia = data.getUTCDate();
                let hora = data.getUTCHours();
                let minuto = data.getUTCMinutes();

                // Adiciona um zero à esquerda se o mês, dia, hora ou minuto for menor que 10
                mes = mes < 10 ? '0' + mes : mes;
                dia = dia < 10 ? '0' + dia : dia;
                hora = hora < 10 ? '0' + hora : hora;
                minuto = minuto < 10 ? '0' + minuto : minuto;

                let dataFormatada = `${ano}-${mes}-${dia}T${hora}:${minuto}`;


                setDtRegisterADD({
                    horary: dataFormatada,
                    dtRef: row.dtRef
                });
            }
        } catch (error) {
            console.log(error)
        }
    }

    /**
     * função para fechar modal de fechamento de ponto 
     */
    const onCloseAddTimesheet = () => {
        // setOpenTreatmentPoint(false);
        setEditPoint(false);
        setAddPoint(false);
        setOpenWarningTimesheet(true)
        setOpenMenuTimesheet(false);
    };

    /**
     * variaveis para abonos 
     */
    const [valueAllowance, setValueAllowance] = useState('Type')
    const [openModalAllowance, setOpenModalAllowance] = useState(false)
    const [dateAllowance, setDateAllowance] = useState()
    const [horaryAllowance, setHoraryAllowance] = useState()
    const [justificationChange, setJustificationChange] = useState('')
    const [observationAllowance, setObservationAllowance] = useState()
    const [dtFrom, setDtFrom] = useState()
    const [dtTo, setDtTo] = useState()



    /**
     * 
     * @param {*} event valor do abono 
     * @param {*} type tipo de variavel
     */
    const handleInputTimeAndHoraryAllowance = (event, type) => {
        console.log(event)
        switch (type) {
            case 'observation':
                setJustificationChange(event)
                break;

            case 'compensationDate':
                setDateAllowance(event)
                break;

            case 'allowanceHours':
                setHoraryAllowance(event)
                break;
            case 'dtFrom':
                setDtFrom(event)
                break;
            case 'dtTo':
                setDtTo(event)
                break;

            default:
                break;
        }
    }

    const handleOpenAllowance = () => {
        setOpenModalAllowance(true)
    }

    const handleCloseAllowance = () => {
        setOpenModalAllowance(false)
        setOpenMenuTimesheet(false)
    }

    const [ruleDECLARATION_ATTENDANCE, setRuleDECLARATION_ATTENDANCE] = useState()
    const [ruleHOME_OFFICE, setRuleHOME_OFFICE] = useState()

    const typesAllowaces = [
        { value: 'Type', displayValue: 'Tipo' },
        { value: 'VACATION', displayValue: 'FÉRIAS', expectedRule: null },
        { value: 'JUST_ABS', displayValue: 'FALTA JUSTIFICADA', expectedRule: null },
        { value: 'OPTIONAL_DAY', displayValue: 'PONTO FACULTATIVO', expectedRule: null },
        { value: 'WORK_LEAVE', displayValue: ' DIA DE FOLGA', expectedRule: null },
        { value: 'LEAVE_OF_ABSENCE', displayValue: 'LICENÇA/AFASTAMENTO', expectedRule: null },
        { value: 'SUNDAY_OR_HOLIDAY_COMPENSATION', displayValue: 'COMPENSAÇÃO DE DOMINGO/FERIADO', expectedRule: 'REDUCE_TOTAL_WORKING_MINUTES' },
        { value: 'ALLOWANCE_HOURS', displayValue: 'ABONO DE HORAS', expectedRule: 'REDUCE_EXPECTED_WORKING' }, 
        { value: 'OUT_JUST_ABSENCE', displayValue: 'FALTA SEM JUSTIFICATIVA', expectedRule: 'OUT_JUST_ABSENCE' },
        { value: 'JUSTIFIED_DELAY', displayValue: 'ATRASO JUSTIFICADO', expectedRule: 'REDUCE_EXPECTED_WORKING' },
        { value: 'OUTPUT_SERVICE', displayValue: 'SAIDA Á SERVIÇO', expectedRule: 'REDUCE_EXPECTED_WORKING' },
        { value: 'DECLARATION_ATTENDANCE', displayValue: 'DECLARAÇÃO DE COMPARECIMENTO', expectedRule: ruleDECLARATION_ATTENDANCE },
        { value: 'BANK_HOURS_COMPENSATION', displayValue: 'COMPENSAR NO BANCO DE HORAS', expectedRule: 'REDUCE_BANK_HOURS' },
        { value: 'MISSING_TIME', displayValue: 'HORA FALTA', expectedRule: 'MISSING_TIME' },
        { value: 'HOME_OFFICE', displayValue: 'HOME OFFICE' },
        { value: 'CHANGE_DAY', displayValue: 'TROCA DE FOLGA', expectedRule: 'CHANGE_DAY' },
        { value: 'INTERJOURNEY_PER_DAY', displayValue: 'INTERJORNADA POR DIA', expectedRule: null }
    ];

    const vacationAllowanceHours = [
        { value: 'ALLOWANCE_HOURS' },
        { value: 'JUSTIFIED_DELAY' },
        { value: 'OUTPUT_SERVICE' },
        { value: 'DECLARATION_ATTENDANCE' },
        { value: 'MISSING_TIME' }
    ]


    const observationsAllowance = [
        { value: 'Observation', displayValue: 'Observação' },
        { value: 'AFASTAMENTO PELO INSS', displayValue: 'AFASTAMENTO PELO INSS' },
        { value: 'LICENÇA MATERNIDADE', displayValue: 'LICENÇA MATERNIDADE' },
        { value: 'ATESTADO MÉDICO', displayValue: 'ATESTADO MÉDICO' },
        { value: 'DECLARAÇÃO DE ÓBITO', displayValue: 'DECLARAÇÃO DE ÓBITO' },
        { value: 'LICENÇA PATERNIDADE', displayValue: 'LICENÇA PATERNIDADE' },
        { value: 'LICENÇA POR CASAMENTO', displayValue: 'LICENÇA POR CASAMENTO' },
        { value: 'LICENÇA AMAMENTAÇÃO', displayValue: 'LICENÇA AMAMENTAÇÃO' },
        // { value: 'outro', displayValue: 'outro' }
    ]

    const typesReduce = [
        { value: 'REDUCE_EXPECTED_WORKING', displayValue: 'Abonar horas' },
        { value: 'REDUCE_BANK_HOURS', displayValue: 'Compensar no banco de horas ' }
    ]

    const typesHome = [
        { value: 'TOTAL_WORKING_EQUAL_EXPECTED', displayValue: 'Carga horária conforme escala de trabalho atual' },
        { value: 'NONE', displayValue: 'Carga horária pré-assinalada da escala de trabalho atual' }
    ]

    function formatDate(date) {
        // const year = date.getFullYear();
        // const month = (date.getMonth() + 1).toString().padStart(2, '0');
        // const day = date.getDate().toString().padStart(2, '0');
        return date.toISOString().slice(0, 10);
    }

    function formatDateNext(date) {
        date.setDate(date.getDate() + 1);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const [openAddPoint, setOpenAddPoint] = useState(null)
    const [openHistory, setOpenHistory] = useState(false)

    const historyModal = (row) => {
        setValueAllowance(row?.allowancesAndDaysOff?.value)
        setRow(row)
        setJustificationChange(row?.allowanceData?.[0]?.observation);
        if (row.allowanceData?.[0]?.allowanceHours) {
            const date = new Date()
            const hours = converterParaHoras(row.allowanceData?.[0]?.allowanceHours)
            date.setHours(hours.split(':')[0])
            date.setMinutes(hours.split(':')[1])
            setHoraryAllowance(date)
        }
        setOpenHistory(true)
    }

    const deleteVacations = async row => {
        try {
            const response = await axiosInstance.post('/vacations/lot/delete', {
                "ids": [row.allowanceData[0].id]
            })
            if (response.status == 200) {
                setSuccesMessage('Abono deletado com sucesso')
                setSuccesMessageBoolean(true)
                setValueAllowance('Type')
                setJustificationChange('')
                handleCloseAllowance();
                workedDaysConfig();
            }
        } catch (error) {
            console.error(error)
            setMessageError(error)
            setErrorBoolean(true)
            handleCloseAllowance()
        }
    };


    const handleAllowanceClick = async (row) => {
        try {
            handleCloseAllowance();
            const allowanceDate = formatDate(new Date(row.dtRef));
            const nextDay = formatDateNext(new Date(row.dtRef));
            const expectedRule = typesAllowaces.find(allowance => allowance.value == valueAllowance);
            const hasAllowanceHours = vacationAllowanceHours.find(allowance => allowance.value == valueAllowance);
            const allowanceHours = hasAllowanceHours ? (horaryAllowance?.getHours() * 60) + horaryAllowance?.getMinutes() : null;
            let data = {
                "dtFrom": dtFrom ? formatDate(new Date(dtFrom)) : allowanceDate,
                "dtTo": dtTo ? formatDate(new Date(dtTo)) : allowanceDate,
                "category": valueAllowance,
                "observation": justificationChange,
                "compensationDate": dateAllowance || null,
                "allowanceHours": allowanceHours || null,
                "expectedRule": valueAllowance == 'HOME_OFFICE' ? ruleHOME_OFFICE : expectedRule.expectedRule || null,
                "employees": [
                    employeeSelectedData.id
                ]
            }

            let method = 'post'
            if (row.allowanceData?.[0]?.id) {
                data.ids = [row.allowanceData?.[0]?.id]
                method = 'put'
            }

            // console.log(data, method, row)

            await axiosInstance.request({
                method: method,
                url: 'https://api.puntu.digital/vacations/lot/',
                data: data
            })
            workedDaysConfig();
            const company = JSON.parse(localStorage.getItem('companies')).find(Id => Id.companyId);
            usageLog("nova_tela_tratamento/visualizacao/abonos", company.companyId, company.userId)
            setSuccesMessage(row?.allowanceData?.length == 0 ? 'Abono criado com sucesso' : 'Abono editado com sucesso')
            setSuccesMessageBoolean(true)

        } catch (error) {
            setMessageError(error)
            setErrorBoolean(true)
            setAutoFix(false)
            handleCloseAllowance();
            console.log(error)
        }
    }



    ///////////////////////////////////////// EVENTOS /////////////////////////////////////////////
    const [missingPoints, setMissingPoints] = useState(0)
    const [eventJustification, setEventJustification] = useState([])
    const [eventLocation, setEventLocation] = useState([])


    const eventEmployee = async (dtFrom, dtTo) => {
        try {
            const employeeId = {
                employeeId: employeeSelectedData.id
            }
            const response = await axiosInstance.post('event/employeeId', employeeId)
            const justificationEvent = response.data.filter(event => event.typeEventId == 4)
            const location = response.data.filter(event => event.typeEventId == 1)
            const primeiroElemento = dtFrom
            const ultimoElemento = dtTo
            const dateLocation = []
            for (let event of location) {
                const dtFrom = new Date(primeiroElemento)
                const dtTo = new Date(ultimoElemento)
                const dateAction = new Date(event.DateAction)
                if (dateAction > dtFrom && dateAction < dtTo) {
                    dateLocation.push(event)
                }

            }
            const dateJustification = []
            for (let event of justificationEvent) {
                const dtFrom = new Date(primeiroElemento)
                const dtTo = new Date(ultimoElemento)
                const dateAction = new Date(event.DateAction)
                if (dateAction > dtFrom && dateAction < dtTo) {
                    dateJustification.push(event)
                }
            }

            setEventJustification(dateJustification)
            setEventLocation(dateLocation)
            return dateLocation

        } catch (error) {
            setMessageError(error.message)
            setErrorBoolean(true)
            setAutoFix(false)
            console.log(error)
        }
    }

    const bigNumbersTimesheet = async (timeSheets, schedule, newJsonReportData) => {
        try {
            // const holidays = newJsonReportData.config[0].holidaysData
            if (schedule) {

                let missingTimesheets = 0
                timeSheets.forEach(timesheet => {
                    if (new Date(timesheet.dtRef) < new Date()) {

                        const weekOfDay = new Date(timesheet.dtRef).getUTCDay()
                        const weekDayExpected = schedule.find(typeDay => typeDay[0] == weekOfDay)
                        if (weekDayExpected) {
                            let countExpected = 0
                            // let countRegistered = 0
                            const expectedTimeclocks = weekDayExpected[1].orderedShiftConfigs.map(shift => {
                                if (shift.clockInTime) {
                                    countExpected = countExpected + 1
                                }
                                if (shift.clockOutTime) {
                                    countExpected = countExpected + 1
                                }
                            })

                            const registeredCount = []
                            const count = [
                                Object.keys(timesheet.entryOne).length === 0 ? null : timesheet.entryOne,
                                Object.keys(timesheet.saleOne).length === 0 ? null : timesheet.saleOne,
                                Object.keys(timesheet.entryTwo).length === 0 ? null : timesheet.entryTwo,
                                Object.keys(timesheet.saleTwo).length === 0 ? null : timesheet.saleTwo,

                            ]
                            for (let timeSheetType of count) {
                                if (timeSheetType) {
                                    registeredCount.push(timeSheetType)
                                }
                            }
                            const holidays = newJsonReportData?.timeclockData.config.length > 0 ? newJsonReportData?.timeclockData.config?.[0].holidaysData : []
                            const findHoliday = holidays.filter(holiday => new Date(holiday.dtRef).setHours(new Date(holiday.dtRef).getHours() + 3) == new Date(timesheet.dtRef).getTime())

                            const missing = timesheet.shifts.length - countExpected
                            if (missing < 0 && timesheet.allowancesAndDaysOff) {
                                if (findHoliday.length > 0) {
                                    missingTimesheets = missingTimesheets
                                } else {
                                    missingTimesheets = missingTimesheets + 1
                                }
                            }
                        }
                    }

                })

                setMissingPoints(missingTimesheets)
            }
        } catch (error) {
            setMessageError(error.message)
            setErrorBoolean(true)
            setAutoFix(false)
            console.log(error)
        }

    }

    const evetnMap = async (type) => {
        try {
            const findEvent = eventLocation.find(event => event.timeclockId == timesheetRow.timeclockId)
            const event = await aprovedEvent(findEvent.id, type)
            handleCloseActionsModal();
        } catch (error) {
            console.log('error')
        }
    }

    const aprovedEvent = async (ids, type) => {
        try {
            setAutoFix(true)
            const data = {
                id: ids,
                statusaction: type == "APROVADO" ? "APROVADO" : "REJEITADO",
                description: type == "APROVADO" ? "aprovado pelo gestor" : "rejeitado pelo gestor"
            }
            const response = await axiosInstance.put('event/', data)
            if (response.data) {
                setAutoFix(false)
            }
            workedDaysConfig();
            const company = JSON.parse(localStorage.getItem('companies')).find(Id => Id.companyId);
            usageLog("nova_tela_tratamento/visualizacao/aprovar_eventos", company.companyId, company.userId)

        } catch (error) {
            setMessageError(error.message)
            setErrorBoolean(true)
            setAutoFix(false)
            console.log(error)
        }
    }

    let filterGroup = {
        buttonBack: page,
        setPage: nextPageOrBack,
        page: page,
        handleChangeFilter: handleChangeFilter,
        employeeData: employeeData,
        department: department,
        employeeDataFilter: employeeDataFilter,
        filterEmployee: filterEmployee,
        period: period,
        setPeriod: setPeriod,
        employeeSelected: employeeSelected,
        selectedEmployee: selectedEmployee,
        selectedDepartment: selectedDepartment,
        selectPeriod: selectPeriod,
        setSelectedPeriod: setSelectedPeriod,
        objPeriod: objPeriod,
        handleChangePeriod: handleChangePeriod,
        endDate: endDate,
        startDate: startDate,
        viewEmployees: viewEmployees,
        autoFix: autoFix,
    }

    let filterGroup2 = {
        position: position,
        alphabet: alphabet,
        setPosition: setPosition,
        larguraDaTela: larguraDaTela,
        atualizarTamanhoDaTela: atualizarTamanhoDaTela,
        employeeSelected: employeeSelected,
        selectedDepartment: selectedDepartment,
        selectPeriod: selectPeriod,
        periodSelect: periodSelect,
    }

    let employeeInformation = {
        larguraDaTela: larguraDaTela,
        atualizarTamanhoDaTela: atualizarTamanhoDaTela,
        employeeSelected: employeeSelected,
        schedule: schedule,
        employeeDataFilter: employeeDataFilter,
        handlePrevious: handlePrevious,
        handleNext: handleNext,
        setScheduleDays: setScheduleDays,
        scheduleDays: scheduleDays,
    }

    let treatmentIndividual = {
        larguraDaTela: larguraDaTela,
        atualizarTamanhoDaTela: atualizarTamanhoDaTela,
        missingPoints: missingPoints,
        eventLocation: eventLocation,
        eventJustification: eventJustification,
        aprovedEvent: aprovedEvent,
        postAutoFix: postAutoFix,
    }

    let reportGroup = {
        data: dataReport,
        openTreatmentPoint: openTreatmentPoint,
        setOpenTreatmentPoint: setOpenTreatmentPoint,
        // onCloseTreatment: onCloseTreatment,
        editPoint: editPoint,
        setEditPoint: setEditPoint,
        setAddPoint: setAddPoint,
        addPoint: addPoint,
        setType: setType,
        setDtRegisterADD: setDtRegisterADD,
        setJustificationADD: setJustificationADD,
        creatTimesheet: creatTimesheet,
        fotoModal: fotoModal,
        getModalPicture: getModalPicture,
        modalPicture: modalPicture,
        handleClosePicture: handleClosePicture,
        openModalAllowance: openModalAllowance,
        handleOpenAllowance: handleOpenAllowance,
        typesAllowaces: typesAllowaces,
        observationsAllowance: observationsAllowance,
        typesReduce: typesReduce,
        typesHome: typesHome,
        handleCloseAllowance: handleCloseAllowance,
        handleInputTimeAndHoraryAllowance: handleInputTimeAndHoraryAllowance,
        setJustificationChange: setJustificationChange,
        dateAllowance: dateAllowance,
        horaryAllowance: horaryAllowance,
        setHoraryAllowance: setHoraryAllowance,
        justificationChange: justificationChange,
        setValueAllowance: setValueAllowance,
        valueAllowance: valueAllowance,
        deleteVacations: deleteVacations,
        setOpenMenuTimesheet: setOpenMenuTimesheet,
        openMenuTimesheet: openMenuTimesheet,
        openModalActionsTimesheet: openModalActionsTimesheet,
        handleOpenActionsModal: handleOpenActionsModal,
        handleCloseActionsModal: handleCloseActionsModal,
        viewLocation: viewLocation,
        handleViewLocation: handleViewLocation,
        handleCloseViewLocation: handleCloseViewLocation,
        setTimesheetRow: setTimesheetRow,
        timesheetRow: timesheetRow,
        handleOpenPicture: handleOpenPicture,
        setDtRegisterUpdate: setDtRegisterUpdate,
        setJustificationUpdate: setJustificationUpdate,
        dtRegisterUpdate: dtRegisterUpdate,
        justficationUpadate: justficationUpadate,
        updateTimesheet: updateTimesheet,
        updateTimsheet: updateTimsheet,
        setJustificationDelete: setJustificationDelete,
        timesheetDelete: timesheetDelete,
        openModalTimesheetDelete: openModalTimesheetDelete,
        closeModalTimesheetDelete: closeModalTimesheetDelete,
        deleteTimesheet: deleteTimesheet,
        setDayMissingJustification: setDayMissingJustification,
        openModalMissingDay: openModalMissingDay,
        handleOpenModalMissingDay: handleOpenModalMissingDay,
        handleCloseModalMissingDay: handleCloseModalMissingDay,
        missingDay: missingDay,
        evetnMap: evetnMap,
        anchorElAtividade: anchorElAtividade,
        row: row,
        handleMenuOpenAtividade: handleMenuOpenAtividade,
        handleMenuCloseAtividade: handleMenuCloseAtividade,
        setRow: setRow,
        autoFix: autoFix,
        handleAllowanceClick: handleAllowanceClick,
        setRuleDECLARATION_ATTENDANCE: setRuleDECLARATION_ATTENDANCE,
        ruleDECLARATION_ATTENDANCE: ruleDECLARATION_ATTENDANCE,
        setRuleHOME_OFFICE: setRuleHOME_OFFICE,
        ruleHOME_OFFICE: ruleHOME_OFFICE,
        messageError: messageError,
        errorBoolean: errorBoolean,
        handleCloseErrorMessage: handleCloseErrorMessage,
        handleCloseMessageSucces: handleCloseMessageSucces,
        succesMessage: succesMessage,
        succesMessageBoolean: succesMessageBoolean,
        dtTo: dtTo,
        dtFrom: dtFrom,
        countColumns: countColumns,
        type: type,
        handleOpenModalUpdate: handleOpenModalUpdate,
        handleOpenModalADD: handleOpenModalADD,
        dtRegisterADD: dtRegisterADD,
        schedule: schedule,
        processRow: processRow,
        ocultarPontosRemovidos: ocultarPontosRemovidos,
        setOcultarPontosRemovidos: setOcultarPontosRemovidos,
        arrayOrdenado: arrayOrdenado,
        menuTimesheet: menuTimesheet,
        setMenuTimesheet: setMenuTimesheet,
        diffTimeSchedule: diffTimeSchedule,
        startLoading: startLoading,
        loadingHistory: loadingHistory,
        idCreatedTimesheet: idCreatedTimesheet,
        setIdCreatedTimesheet: setIdCreatedTimesheet,
        converterParaHoras: converterParaHoras,
        historyModal: historyModal,
        setOpenHistory: setOpenHistory,
        openHistory: openHistory,
        setOpenAddPoint: setOpenAddPoint,
        openAddPoint: openAddPoint,
        menuTimesheetRemoved: menuTimesheetRemoved,
        setMenuTimesheetRemoved: setMenuTimesheetRemoved,
        updateRemovedTimesheet: updateRemovedTimesheet,
    };


    return {
        filterGroup,
        filterGroup2,
        employeeInformation,
        treatmentIndividual,
        reportGroup,
        larguraDaTela,
        schedule,
        page
    }
}

export default AccompanimentModel;